'use client';
import algoliasearch from 'algoliasearch';
import { useEffect, useState } from 'react';
import 'react-multi-carousel/lib/styles.css';
import Link from 'next/link';
import classes from './MoreFromThisSeller.module.css';
import BlogCarouselItem from './BlogCarouselItem';

const client =
	process.env.NEXT_PUBLIC_OG_DB === 'true'
		? algoliasearch(
				process.env.NEXT_PUBLIC_ALGOLIA_APPID,
				process.env.NEXT_PUBLIC_ALGOLIA_API_KEY
		  )
		: algoliasearch(
				process.env.NEXT_PUBLIC_DUMMY_ALGOLIA_APPID,
				process.env.NEXT_PUBLIC_DUMMY_ALGOLIA_API_KEY
		  );

const MoreFromThisSeller = (props) => {
	const { sellerId } = props;

	const [text, setText] = useState('Discover some popular items');

	const [link, setLink] = useState('/collections');

	const [displayListings, setDisplayListings] = useState([]);

	const getListings = async (section) => {
		const index = client.initIndex('kashew_listings');

		const isSeller =
			sellerId && sellerId !== '' && sellerId !== 'undefined'
				? sellerId
				: false;

		console.log('isSeller', isSeller);

		await index
			.search(isSeller ? sellerId : '', {
				hitsPerPage: 15,
				page: 0,
				filters: isSeller
					? `status:active`
					: `status:active${
							section === 'iconic_designs' ? ' AND iconicDesign:true' : ''
					  }`,
				clickAnalytics: true,
			})
			.then(async (res) => {
				setDisplayListings(res.hits);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	useEffect(() => {
		let newSection = sellerId
			? 'more_from_seller'
			: window?.location?.pathname?.includes('blog')
			? 'iconic_designs'
			: 'popular_items';

		setText(
			newSection === 'more_from_seller'
				? 'Items from this seller'
				: newSection === 'iconic_designs'
				? 'Discover some iconic pieces'
				: 'Discover some popular items'
		);

		setLink(
			newSection === 'more_from_seller'
				? `/profile/${sellerId}`
				: newSection === 'iconic_designs'
				? '/selections/iconic-designs'
				: '/collections'
		);

		getListings(newSection);
	}, [sellerId]);

	return (
		<>
			{displayListings?.length > 0 && (
				<div className={classes.similarItems}>
					<div className={classes.headerBox}>
						<h6 className={classes.header}>{text}</h6>

						<Link className={classes.Link} href={link}>
							<h6 className={classes.seeAll}>See all</h6>
						</Link>
					</div>
					<section className={classes.scrollWrapper}>
						<section className={classes.uWrapper}>
							<ul className={classes.list}>
								{displayListings?.map((listing, idx) => (
									<BlogCarouselItem listing={listing} idx={idx} />
								))}
							</ul>
						</section>
					</section>
				</div>
			)}
		</>
	);
};

export default MoreFromThisSeller;
